import React from 'react';

// Базовый компонент для всех иконок
const BaseIcon = ({ children, className = "", size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    {children}
  </svg>
);

// Ракета 🚀
export const RocketIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="rocket-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path
      d="M12 2L13.09 8.26L20 9L14.74 12.74L16.18 19.74L12 17L7.82 19.74L9.26 12.74L4 9L10.91 8.26L12 2Z"
      fill="url(#rocket-gradient)"
    />
    <path
      d="M12 15L8 19L9 21L12 18L15 21L16 19L12 15Z"
      fill="url(#rocket-gradient)"
      opacity="0.8"
    />
  </BaseIcon>
);

// Цель 🎯
export const TargetIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="target-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#10b981', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="10" stroke="url(#target-gradient)" strokeWidth="2"/>
    <circle cx="12" cy="12" r="6" stroke="url(#target-gradient)" strokeWidth="2"/>
    <circle cx="12" cy="12" r="2" fill="url(#target-gradient)"/>
  </BaseIcon>
);

// Ключ 🔑
export const KeyIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="key-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#f59e0b', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <circle cx="8" cy="8" r="6" fill="url(#key-gradient)"/>
    <path d="M14.5 13.5L21 20L20 21L13.5 14.5" stroke="url(#key-gradient)" strokeWidth="2"/>
    <path d="M17 17L18 16" stroke="url(#key-gradient)" strokeWidth="2"/>
    <path d="M19 19L20 18" stroke="url(#key-gradient)" strokeWidth="2"/>
  </BaseIcon>
);

// Алмаз 💎
export const DiamondIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="diamond-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path
      d="M6 3L12 1L18 3L21 9L12 22L3 9L6 3Z"
      fill="url(#diamond-gradient)"
    />
    <path
      d="M6 9L12 22L18 9L15 3L9 3L6 9Z"
      fill="url(#diamond-gradient)"
      opacity="0.6"
    />
  </BaseIcon>
);

// Телефон 📱
export const PhoneIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="phone-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" fill="url(#phone-gradient)"/>
    <line x1="12" y1="18" x2="12.01" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <rect x="7" y="4" width="10" height="12" fill="white" fillOpacity="0.2" rx="1"/>
  </BaseIcon>
);

// Компьютер 💻
export const LaptopIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="laptop-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#6366f1', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path
      d="M20 16V7C20 5.89 19.1 5 18 5H6C4.89 5 4 5.89 4 7V16H20Z"
      fill="url(#laptop-gradient)"
    />
    <path
      d="M2 18H22V19C22 19.55 21.55 20 21 20H3C2.45 20 2 19.55 2 19V18Z"
      fill="url(#laptop-gradient)"
    />
    <rect x="6" y="7" width="12" height="8" fill="white" fillOpacity="0.2" rx="1"/>
  </BaseIcon>
);

// Монитор 🖥️
export const MonitorIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="monitor-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" fill="url(#monitor-gradient)"/>
    <line x1="8" y1="21" x2="16" y2="21" stroke="url(#monitor-gradient)" strokeWidth="2"/>
    <line x1="12" y1="17" x2="12" y2="21" stroke="url(#monitor-gradient)" strokeWidth="2"/>
    <rect x="4" y="5" width="16" height="10" fill="white" fillOpacity="0.2" rx="1"/>
  </BaseIcon>
);

// Лампочка 💡
export const BulbIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="bulb-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#f59e0b', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path
      d="M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21Z"
      fill="url(#bulb-gradient)"
    />
    <path
      d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2Z"
      fill="url(#bulb-gradient)"
    />
  </BaseIcon>
);

// Замок 🔒
export const LockIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="lock-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#ef4444', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" fill="url(#lock-gradient)"/>
    <path d="M7 11V7C7 4.24 9.24 2 12 2S17 4.24 17 7V11" stroke="url(#lock-gradient)" strokeWidth="2" fill="none"/>
    <circle cx="12" cy="16" r="2" fill="white" fillOpacity="0.8"/>
  </BaseIcon>
);

// Глобус 🌍
export const GlobeIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="globe-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#10b981', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="10" stroke="url(#globe-gradient)" strokeWidth="2" fill="none"/>
    <path d="M2 12H22" stroke="url(#globe-gradient)" strokeWidth="2"/>
    <path d="M12 2C14.5 4.5 16 8.5 16 12S14.5 19.5 12 22C9.5 19.5 8 15.5 8 12S9.5 4.5 12 2Z" stroke="url(#globe-gradient)" strokeWidth="2" fill="none"/>
  </BaseIcon>
);

// Молния ⚡
export const LightningIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="lightning-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#f59e0b', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path
      d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
      fill="url(#lightning-gradient)"
    />
  </BaseIcon>
);

// Свободный/Бесплатно 🆓
export const FreeIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="free-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#10b981', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <rect x="2" y="4" width="20" height="16" rx="3" ry="3" fill="url(#free-gradient)"/>
    <path d="M7 8H17" stroke="white" strokeWidth="2"/>
    <path d="M7 12H13" stroke="white" strokeWidth="2"/>
    <path d="M7 16H15" stroke="white" strokeWidth="2"/>
  </BaseIcon>
);

// Звезда ✨
export const SparkleIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="sparkle-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#f59e0b', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="url(#sparkle-gradient)"/>
    <path d="M6 4L6.5 5.5L8 6L6.5 6.5L6 8L5.5 6.5L4 6L5.5 5.5L6 4Z" fill="url(#sparkle-gradient)"/>
    <path d="M18 16L18.5 17.5L20 18L18.5 18.5L18 20L17.5 18.5L16 18L17.5 17.5L18 16Z" fill="url(#sparkle-gradient)"/>
  </BaseIcon>
);

// Праздник/Вечеринка 🎉
export const PartyIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="party-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path d="M5 12L12 3L19 12L17 14L12 9L7 14L5 12Z" fill="url(#party-gradient)"/>
    <circle cx="8" cy="16" r="2" fill="url(#party-gradient)"/>
    <circle cx="16" cy="16" r="2" fill="url(#party-gradient)"/>
    <circle cx="12" cy="20" r="2" fill="url(#party-gradient)"/>
    <path d="M4 8L6 6" stroke="url(#party-gradient)" strokeWidth="2"/>
    <path d="M20 8L18 6" stroke="url(#party-gradient)" strokeWidth="2"/>
    <path d="M2 12L4 10" stroke="url(#party-gradient)" strokeWidth="2"/>
    <path d="M22 12L20 10" stroke="url(#party-gradient)" strokeWidth="2"/>
  </BaseIcon>
);

// Обновление/Перезагрузка 🔄
export const RefreshIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="refresh-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path d="M21.5 2V6H17.5" stroke="url(#refresh-gradient)" strokeWidth="2" fill="none"/>
    <path d="M2.5 22V18H6.5" stroke="url(#refresh-gradient)" strokeWidth="2" fill="none"/>
    <path d="M20.49 9C19.9 5.81 16.98 3.5 13.5 3.5C11.09 3.5 8.93 4.73 7.64 6.66L2.5 6" stroke="url(#refresh-gradient)" strokeWidth="2" fill="none"/>
    <path d="M3.51 15C4.1 18.19 7.02 20.5 10.5 20.5C12.91 20.5 15.07 19.27 16.36 17.34L21.5 18" stroke="url(#refresh-gradient)" strokeWidth="2" fill="none"/>
  </BaseIcon>
);

// Пользователи 👥
export const UsersIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="users-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#10b981', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <circle cx="9" cy="7" r="4" fill="url(#users-gradient)"/>
    <path d="M3 21v-2c0-2.21 1.79-4 4-4h4c2.21 0 4 1.79 4 4v2" stroke="url(#users-gradient)" strokeWidth="2" fill="none"/>
    <circle cx="16" cy="4" r="2" fill="url(#users-gradient)"/>
    <path d="M20 8v6M20 21v-3c0-1-0.8-2-2-2h-1" stroke="url(#users-gradient)" strokeWidth="2" fill="none"/>
  </BaseIcon>
);

// Загрузка 📥
export const DownloadIcon = ({ className = "", size = 24 }) => (
  <BaseIcon className={className} size={size}>
    <defs>
      <linearGradient id="download-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor: '#10b981', stopOpacity: 1}} />
        <stop offset="50%" style={{stopColor: '#06b6d4', stopOpacity: 1}} />
        <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
      </linearGradient>
    </defs>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="url(#download-gradient)" strokeWidth="2" fill="none"/>
    <polyline points="7,10 12,15 17,10" stroke="url(#download-gradient)" strokeWidth="2" fill="none"/>
    <line x1="12" y1="15" x2="12" y2="3" stroke="url(#download-gradient)" strokeWidth="2"/>
  </BaseIcon>
);

export default {
  RocketIcon,
  TargetIcon,
  KeyIcon,
  DiamondIcon,
  PhoneIcon,
  LaptopIcon,
  MonitorIcon,
  BulbIcon,
  LockIcon,
  GlobeIcon,
  LightningIcon,
  FreeIcon,
  SparkleIcon,
  PartyIcon,
  RefreshIcon,
  UsersIcon,
  DownloadIcon
};